module.exports = __webpack_public_path__ + "static/media/IMG_0143.7d2b7a83.JPG";